// home page component
import { useEffect } from "react";
import Behance from "../../components/icons/Behance";
import Dribbble from "../../components/icons/Dribbble";
import Facebook from "../../components/icons/Facebook";
import Github from "../../components/icons/Github";
import Instagram from "../../components/icons/Instagram";
import Twitter from "../../components/icons/Twitter";
import H1 from "../../components/utils/H1";
import { socialMedia, name } from "../../data/data";

export default function Home() {
	useEffect(() => {
		document.title = `${name.firstName} ${name.surname}`;
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, []);

	return (
		<div className="flex flex-col items-center justify-center h-screen sm:px-20 text-center animate__animated  animate__fadeIn">
			<H1>
				{name.firstName} <span className="text-primary">{name.surname}</span>
			</H1>
			<p className="mb-5">
				Curabitur aliquet quam id dui posuere blandit. Vivamus suscipit tortor
				eget felis porttitor volutpat.
			</p>
			<div className="flex space-x-2">
				{/* display social media links */}
				{socialMedia.twitter && <Twitter username={socialMedia.twitter} />}
				{socialMedia.facebook && <Facebook username={socialMedia.facebook} />}
				{socialMedia.github && <Github username={socialMedia.github} />}
				{socialMedia.instagram && (
					<Instagram username={socialMedia.instagram} />
				)}
				{socialMedia.dribbble && <Dribbble username={socialMedia.dribbble} />}
				{socialMedia.behance && <Behance username={socialMedia.behance} />}
			</div>
		</div>
	);
}
